import { Navigate, Outlet } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { useAuth } from "../context/AuthContext";

/**
 * Route-level variant of `RequireBookingAdmin`. Use as `<Route element={<RequireBookingAdminRoute />}>`
 * to guard a whole sub-tree without each child page importing the wrapper.
 * Non-admins are redirected to "/" (instead of seeing a flash of admin chrome).
 */
export default function RequireBookingAdminRoute(): JSX.Element {
  const { hasBookingAdmin, loading } = useAuth();
  if (loading) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" minHeight="50vh">
        <Typography color="text.secondary">Зөвшөөрөл шалгаж байна…</Typography>
      </Box>
    );
  }
  if (!hasBookingAdmin()) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
